import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { yearFirstDateTimeFormatInTimezone } from "src/utils/timezoneFormat";

export const reportListColumn = (isReadOnly, timeZone) => ([
    {
        field: "transactionId",
        headerName: "Transaction ID",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value, id }) => (
            <>
                {isReadOnly ? value : <Link underline="none" component={RouterLink} to={`/transactions/${id}`}>
                    {value}
                </Link>}
            </>
        ),
    },
    {
        field: "userEmail",
        headerName: "Email ID",
        flex: 0.7,
        minWidth: 150,
        renderCell: ({ value }) => (
            <Tooltip title={value || 'N/A'} placement="top">
                <span>{value || 'N/A'}</span>
            </Tooltip>
        ),
    },
    {
        field: "tagId",
        headerName: "Tag",
        flex: 0.7,
        minWidth: 150,
        renderCell: ({ value }) => (
            <Tooltip title={value || 'N/A'} placement="top">
                <span>{value || 'N/A'}</span>
            </Tooltip>
        ),
    },
    {
        field: "startTime",
        headerName: "Start Time",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => {
            const formatted = timeZone
                ? yearFirstDateTimeFormatInTimezone(value, timeZone)
                : yearFirstDateTimeFormat(value);
            return (
                <Tooltip title={formatted} placement="top">
                    <span>{formatted}</span>
                </Tooltip>
            );
        },
    },
    {
        field: "stopTime",
        headerName: "Stop Time",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => {
            const formatted = timeZone
                ? yearFirstDateTimeFormatInTimezone(value, timeZone)
                : yearFirstDateTimeFormat(value);
            return (
                <Tooltip title={formatted} placement="top">
                    <span>{formatted}</span>
                </Tooltip>
            );
        },
    },
    {
        field: "chargeboxId",
        headerName: "Charger Box",
        flex: 0.5,
        minWidth: 100,
        renderCell: ({ value }) => (
            <Tooltip title={value} placement="top">
                <span>{value}</span>
            </Tooltip>
        ),
    },
    {
        field: "connectorId",
        headerName: "Connector ID",
        flex: 0.5,
        minWidth: 105,
    },
    {
        field: "startValue",
        headerName: "Start Value",
        flex: 0.5,
        minWidth: 95,
    },
    {
        field: "stopValue",
        headerName: "Stop Value",
        flex: 0.5,
        minWidth: 95,
    },
    {
        field: "totalEnergy",
        headerName: "Total Energy Consumed",
        flex: 0.7,
        minWidth: 105,
    },
    {
        field: "paymentType",
        headerName: "Transaction Method",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "teamName",
        headerName: "Team Name",
        flex: 0.6,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={value} placement="top">
                <span>{value}</span>
            </Tooltip>
        ),
    },
    {
        field: "gstNumber",
        headerName: "GST Number",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={value || "URP"} placement="top">
                <span>{value || "URP"}</span>
            </Tooltip>
        ),
    },
    {
        field: "amountPaid",
        headerName: "Amount Paid",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "chargingCost",
        headerName: "Transaction Cost",
        flex: 0.5,
        minWidth: 100,
    },
    {
        field: "cmCommission",
        headerName: "ZT Commission",
        flex: 0.5,
        minWidth: 120,
    },
    {
        field: "payoutWithTax",
        headerName: "Payout With GST",
        flex: 0.5,
        minWidth: 100,
    },
    // {
    //     field: "payoutWithoutTax",
    //     headerName: "Payout Without GST",
    //     flex: 0.5,
    //     minWidth: 120,
    // },
    {
        field: "status",
        headerName: "Payout Status",
        flex: 0.5,
        minWidth: 120,
        renderCell: ({ value }) => (
            <Tooltip title={value} placement="top">
                <span>{value}</span>
            </Tooltip>
        ),
    }
]);

export const reportTabListToShow = () => ([
    "transactionId",
    "userEmail",
    "chargeboxId",
    "connectorId",
    "startValue",
    "stopValue",
    "totalEnergy",
    "paymentType",
    "teamName",
    "gstNumber",
    "amountPaid",
    "chargingCost",
    "cmCommission",
    "ztCommission",
    "payoutWithTax",
    "payoutWithoutTax",
    "status",
])

export const reportStatusList = [
    'AUTHORIZED',
    'PAYOUTPENDING',
    'PAYOUTCALCULATED',
    'PAYOUTCOMPLETED',
    'CAPTURED'
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// Show the BI code only, dropping the date suffix (BI-977-29052026 -> BI-977).
export const displayBiCode = (id = "") => id.split("-").slice(0, 2).join("-");

// html2canvas mis-measures collapsed-border tables that rely on vertical-align,
// which makes summary rows overlap and text clip in the PDF (the email client
// renders the same HTML fine). Prepend a scoped style reset that pins table
// layout and cell box-model so the rasterized PDF matches the on-screen layout.
export const PDF_SAFE_STYLE = `
<style>
  /* Keep the invoice within the capture width -> no right-side clipping. */
  [data-invoice-root="true"] { width: 100% !important; max-width: 100% !important; }
  [data-invoice-root="true"] table { max-width: 100% !important; }
  [data-invoice-root="true"] td,
  [data-invoice-root="true"] th {
    box-sizing: border-box !important;
    background-clip: padding-box !important;
  }
  /* Data-table cells (they carry a border): give measurable, compact height so
     html2canvas can't overlap rows, and keep it tight enough for one A4 page. */
  [data-invoice-root="true"] td[style*="border"],
  [data-invoice-root="true"] th[style*="border"] {
    vertical-align: middle !important;
    padding: 6px 8px !important;
    line-height: 1.4 !important;
  }
  [data-invoice-root="true"] td[style*="border"] div { line-height: 1.4 !important; }
  /* Header cells & the SAC code must not wrap/break apart. */
  [data-invoice-root="true"] th { white-space: nowrap !important; }
  [data-invoice-root="true"] td[align="center"][style*="Courier"] { white-space: nowrap !important; }
  /* Rate + amount columns stay on one line so rows don't balloon vertically. */
  [data-invoice-root="true"] td[align="right"][style*="border"],
  [data-invoice-root="true"] td[align="center"][style*="border"] { white-space: nowrap !important; }
  /* Compact the vertical rhythm so the whole invoice fits on a single A4 page. */
  [data-invoice-root="true"] td[style*="padding: 14px 24px"],
  [data-invoice-root="true"] td[style*="padding:14px 24px"] { padding: 8px 24px !important; }
  [data-invoice-root="true"] td[style*="padding: 18px 24px"] { padding: 12px 24px !important; }
  [data-invoice-root="true"] td[style*="margin-bottom: 35px"],
  [data-invoice-root="true"] div[style*="margin-bottom: 35px"] { margin-bottom: 18px !important; }
</style>
`;
export const normalizeInvoiceHtml = (html = "") => `${PDF_SAFE_STYLE}${html}`;

// Select-All helper — mirrors the Statement tab behavior.
export const isAllSelected = (options = [], selected = []) => {
  const allIds = options.map(
    (item) => item.teamId || item.companyId || item.boxId || item
  );
  return allIds.length > 0 && allIds.every((id) => selected.includes(id));
};

export const payoutTableHeaderSx = {
  color: "#9BA3AF",
  fontWeight: 700,
  fontSize: "12px",
  textTransform: "uppercase",
  borderBottom: "1px solid #E8EBF0",
  whiteSpace: "nowrap",
};

export const payoutParentCellSx = {
  borderBottom: "1px solid #E8EBF0",
  paddingTop: "14px",
  paddingBottom: "14px",
};

export const payoutChildHeaderCellSx = {
  color: "#9BA3AF",
  fontWeight: 700,
  fontSize: "12px",
  textTransform: "uppercase",
  borderBottom: "1px solid #EEF1F5",
  backgroundColor: "#FBFCFE",
  whiteSpace: "nowrap",
};

export const payoutChildCellSx = {
  borderBottom: "1px solid #EEF1F5",
  fontSize: "14px",
  color: "#3B4556",
};
